'use client'

import { useEffect } from 'react'
import { useHsRecentlyViewed } from '../../hooks/useHsRecentlyViewed'
import { useAccessControl } from '@/modules/auth/hooks/useAccessControl'

interface HsRecentlyViewedTrackerProps {
  hsCode: string
  description: string
}

/**
 * Headless client component that tracks HS code views in localStorage.
 * Renders nothing — just runs the side effect on mount.
 */
export function HsRecentlyViewedTracker({
  hsCode,
  description,
}: HsRecentlyViewedTrackerProps) {
  const { addItem } = useHsRecentlyViewed()
  const { isAllowed, isLoading } = useAccessControl({ type: 'view-hs-detail', hsCode })

  useEffect(() => {
    // Only track if access is actually allowed and fully loaded
    if (!isLoading && isAllowed) {
      addItem({ hsCode, description })
    }
  }, [hsCode, description, addItem, isAllowed, isLoading])

  return null
}
